import t from '@guestyci/localize/t.macro';
import { utils, okta } from 'utils';
import {
  GUESTY_HELP_TROUBLESHOOTING_LOGIN_URL,
  GUESTY_REQUEST_A_DEMO_URL,
} from 'utils/consts';

import getOktaTranslations from '../../login/oktaLoginTranslations';
import { getRawQueryParam } from './urlHelpers';
import { getLanguage } from './localeHelper';

const getUserLanguage = () => getLanguage().split('-')[0];

const handleRecoveryToken = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const recoveryToken = searchParams.get('token');
  const userEmail = getRawQueryParam(window.location.search, 'mailRef');
  const firstName = getRawQueryParam(window.location.search, 'firstName');

  if (!recoveryToken) {
    return null;
  }

  if (userEmail) {
    window.sessionStorage.setItem('mfaUserEmail', userEmail);

    if (utils.eventsLogger?.unifiedLoginDio) {
      utils.eventsLogger.unifiedLoginDio.track('create_password', 'pageview', {
        userEmail,
      });
    }
  }
  if (firstName) {
    window.sessionStorage.setItem('firstName', firstName);
  }

  const currentUrl = new URL(window.location);
  const paramsToKeep = ['activation', 'package'];
  const newParams = new URLSearchParams();

  paramsToKeep.forEach(param => {
    const value = currentUrl.searchParams.get(param);
    if (value) {
      newParams.append(param, value);
    }
  });

  const search = newParams.toString();
  window.history.replaceState(
    {},
    document.title,
    `${window.location.pathname}${search ? '?' + search : ''}`
  );

  return recoveryToken;
};

export const getWidgetConfig = () => {
  const {
    issuer,
    clientId,
    redirectUri,
    scopes,
    useInteractionCode,
    googleIDPId,
  } = okta.oidc;

  const userLanguage = getUserLanguage();
  const recoveryToken = handleRecoveryToken();

  const oktaLoginTranslations = getOktaTranslations();
  const customTranslations = {
    ...oktaLoginTranslations,
    'primaryauth.submit': t('Sign in'),
  };

  const finalConfig = {
    baseUrl: issuer?.split('/oauth2')[0] || '',
    recoveryToken,
    clientId,
    redirectUri,
    logo: `${process.env.PUBLIC_URL}/guesty-logo-dark-blue-new.svg`,
    logoText: 'Guesty',
    language: userLanguage,
    i18n: {
      [userLanguage]: customTranslations,
    },
    features: {
      rememberMe: true,
      registration: true,
      deviceFingerprinting: true,
      showPasswordRequirementsAsHtmlList: true,
    },
    authParams: {
      issuer,
      scopes,
      prompt: 'consent',
    },
    useClassicEngine: !useInteractionCode,
    brandName: 'Guesty',
    colors: {
      brand: '#2053f8',
    },
    helpLinks: {
      help: GUESTY_HELP_TROUBLESHOOTING_LOGIN_URL,
    },
    registration: {
      click() {
        window.location.href = GUESTY_REQUEST_A_DEMO_URL;
      },
    },
    idps: googleIDPId ? [{ type: 'GOOGLE', id: googleIDPId }] : undefined,
    prompt: 'consent',
    idpDisplay: 'SECONDARY',
  };

  return finalConfig;
};
